import { IBarChartBar } from "@directives/_visualisations/barChart/barChart.component";
import { IDriver } from "@interfaces/IDriver";
import * as angular from "angular";
import { IVideoEntry } from "../models/IVideoEntry";
import "./driverVideoCard.scss";

interface IComponentBindings {
    driver: IDriver;
    videoEvents: IVideoEntry[];
}

interface IBarChartConfig {
    title: string;
    bars: IBarChartBar[];
    totalCount: number;
}

class ComponentController implements angular.IComponentController, IComponentBindings {

    loading = false;

    driver: IDriver;
    videoEvents: IVideoEntry[];
    showMinorEvents: boolean = false;

    tabTitle: string;
    filterStatus: string;

    static $inject = ["cameraService", "veriDate"];

    constructor() {
    }

    $onInit(): void {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {        
    }  

    setSelectedTab(tabTitle: string) {
        this.tabTitle = tabTitle;
    }

    overviewDashboardClick(tabTitle: string, status: string) {
        this.setSelectedTab(tabTitle);
        this.filterStatus = status;
    }
    // ---

   
}

export class DriverVideoCardComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            driver: "<",
            videoEvents: "<"
        };

        this.controller = ComponentController;
        this.template = require("./driverVideoCard.html");
    }
}
